interface WidgetDialogStyleConstraint {
  default: number
  min: number
  max: number
}

interface WidgetDialogStyleConstraints {
  width: WidgetDialogStyleConstraint
  height: WidgetDialogStyleConstraint
  borderRadius: WidgetDialogStyleConstraint
}

export const WIDGET_DIALOG_STYLE_CONSTRAINTS: WidgetDialogStyleConstraints = {
  width: { default: 360, min: 320, max: 400 },
  height: { default: 640, min: 520, max: 720 },
  borderRadius: { default: 12, min: 4, max: 16 },
}

export interface WidgetDialogStyleInput {
  boxWidth?: unknown
  boxHeight?: unknown
  borderRadius?: unknown
}

export interface WidgetDialogCssVariables {
  '--abot-dialog-width': string
  '--abot-dialog-height': string
  '--abot-dialog-radius': string
}

export interface WidgetDialogStyle {
  width: number
  height: number
  borderRadius: number
  cssVariables: WidgetDialogCssVariables
}

const normalizeInteger = (value: unknown, fallback: number, min: number, max: number): number => {
  if (value === null || value === undefined || value === '') return fallback

  const normalizedValue =
    typeof value === 'number'
      ? value
      : typeof value === 'string'
        ? Number(value.trim())
        : Number.NaN

  if (!Number.isFinite(normalizedValue)) return fallback

  return Math.min(max, Math.max(min, Math.floor(normalizedValue)))
}

/**
 * Normalizes untrusted channel style data and exposes the namespaced Shadow DOM
 * variables consumed by the chat window shell.
 */
export const normalizeWidgetDialogStyle = (
  input: WidgetDialogStyleInput = {},
): WidgetDialogStyle => {
  const width = normalizeInteger(
    input.boxWidth,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.width.default,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.width.min,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.width.max,
  )
  const height = normalizeInteger(
    input.boxHeight,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.height.default,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.height.min,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.height.max,
  )
  const borderRadius = normalizeInteger(
    input.borderRadius,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.borderRadius.default,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.borderRadius.min,
    WIDGET_DIALOG_STYLE_CONSTRAINTS.borderRadius.max,
  )

  return {
    width,
    height,
    borderRadius,
    cssVariables: {
      '--abot-dialog-width': `${width}px`,
      '--abot-dialog-height': `${height}px`,
      '--abot-dialog-radius': `${borderRadius}px`,
    },
  }
}
